// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_container__7TiQz","item":"notification_item__1r0HG"};